import LoadingScreen from "@/components/LoadingScreen";
import useLogin from "@/hooks/useLogin";

export default function SSO() {
  const { isSSO } = useLogin();

  return <LoadingScreen message={isSSO ? "Attempting SSO login..." : "Redirecting..."} />;
}
